import { TRootState } from '../storeTypes';
export const getWSState = (state: TRootState) => state.ws;
